import React from 'react';
import {useStyles} from './helper';

const Credit = ({slotCredit, liveCredit}) => {
    const classes = useStyles();

    return (
        <div className={classes.root} style={{padding: '0 20px'}}>
            {
                slotCredit.map((item) => (
                    <span className={classes.helper} style={{display: 'flex', justifyContent: 'space-between', width: '100%'}}>
                        <div style={{width: '50%'}}>
                            {
                                item?.providers?.includes('Playson') && <span>GR-YELLOW</span>
                            }
                            {
                                item?.providers?.includes('Belatra') && <span>GR-GREEN</span>
                            }
                        </div>
                        <div style={{width: '50%'}}>
                            <span style={{color: item.amount < 200000 ? 'red' : '#3cde0b'}}>
                                {new Intl.NumberFormat('ru-RU').format(item.amount ? (+item?.amount).toFixed(2) : item.amount)} {item.currency}
                            </span>
                        </div>
                    </span>
                ))
            } 
            {
                liveCredit.map((item) => (
                    <span className={classes.helper} style={{display: 'flex', justifyContent: 'space-between', width: '100%'}}>
                        <div style={{width: '50%'}}>
                            <span>GR02-GREEN</span>
                        </div>
                        <div style={{width: '50%'}}>
                            <span style={{color: item.amount < 200000 ? 'red' : '#3cde0b'}}>
                                {new Intl.NumberFormat('ru-RU').format(item.amount ? (+item?.amount).toFixed(2) : item.amount)} {item.currency}
                            </span>
                        </div>
                    </span>
                ))
            }
        </div>
    )
}

export default Credit;